import type { PaymentPlanRow } from './widgetHelpers';
import type { WidgetTheme } from './widgetStyles';

/** Municípios mock por UF (sem chamadas IBGE). */
export const MOCK_CIDADES: Record<string, { id: number; nome: string }[]> = {
    RS: [
        { id: 4314902, nome: 'Porto Alegre' },
        { id: 4314407, nome: 'Pelotas' },
    ],
    SP: [
        { id: 3550308, nome: 'São Paulo' },
        { id: 3509502, nome: 'Campinas' },
    ],
    RJ: [
        { id: 3304557, nome: 'Rio de Janeiro' },
        { id: 3301009, nome: 'Niterói' },
    ],
};

export function getMockOffer(offerId: string): {
    id: string;
    name: string;
    active: boolean;
    paymentPlans: PaymentPlanRow[];
} {
    return {
        id: offerId || 'mock-offer',
        name: 'Graduação — Oferta demonstração',
        active: true,
        paymentPlans: [
            {
                id: 'pp_pub_pix',
                customerType: 'Público Geral',
                paymentMethod: 'Pix',
                price: 2500,
                discount: 250,
                installments: 1,
                description: 'Confirmação imediata',
            },
            {
                id: 'pp_pub_cart',
                customerType: 'Público Geral',
                paymentMethod: 'Cartão de Crédito',
                price: 2500,
                discount: 250,
                installments: 12,
                description: 'Parcelamento no cartão',
            },
            {
                id: 'pp_pub_bol',
                customerType: 'Público Geral',
                paymentMethod: 'Boleto',
                price: 2500,
                discount: 0,
                installments: 1,
                description: 'Compensação em até 3 dias úteis',
            },
            {
                id: 'pp_eg_pix',
                customerType: 'Egresso',
                paymentMethod: 'Pix',
                price: 2000,
                discount: 0,
                installments: 1,
                description: '',
            },
            {
                id: 'pp_eg_cart',
                customerType: 'Egresso',
                paymentMethod: 'Cartão de Crédito',
                price: 2000,
                discount: 0,
                installments: 6,
                description: '',
            },
            {
                id: 'pp_eg_bol',
                customerType: 'Egresso',
                paymentMethod: 'Boleto',
                price: 2000,
                discount: 0,
                installments: 1,
                description: '',
            },
        ],
    };
}

export function getMockTheme(_themeId: string): WidgetTheme {
    return {
        backgroundColor: '#213F9A',
        textColor: '#fff',
        accentColor: '#FD4900',
        inputBackgroundColor: '#fff',
        fonts: "system-ui, -apple-system, 'Segoe UI', sans-serif",
        code: 'mock_theme',
    };
}

export const MOCK_BOOTSTRAP = {
    institution_name: 'Unisinos',
    contact_url: 'https://wa.me/5551999999999',
    widget_title: 'GARANTA SUA VAGA',
    acceptance_term_label: 'Li e aceito o termo de inscrição',
    pagarme_public_key: null,
} as const;
